const TestType = {
  ALL_TESTS: 'ALL_TESTS',
  ALL_GROUPS: 'ALL_GROUPS',
  ALL_LIBRARY: 'ALL_LIBRARY',
  ALL_ARCHIVED: 'ALL_ARCHIVED',
  ON_ADD_DATA: 'ON_ADD_DATA',
  ONE_GROUP: 'ONE_GROUP',
  EMPTY_REDUCER: 'EMPTY_REDUCER',
  ALL_OPTIONS: 'ALL_OPTIONS',
  SELECTED_IDS: 'SELECTED_IDS',
  DELETE_TESTING: 'DELETE_TESTING',
  UPDATE_NEW_ORDER_TESTING: 'UPDATE_NEW_ORDER_TESTING',
};

export default TestType;
